import React from 'react';

import PropTypes from 'prop-types';
import Text from '@tds/core-text';
import DimpleDivider from '@tds/core-dimple-divider';
import Notification from '@tds/core-notification';

const StatusBar = ({ status, setStatus }) => {
  return (
    <>
      <Notification
        variant={status.type}
        dismissible
        onExit={() => setStatus({ isVisible: false, text: '' })}
        copy="en"
      >
        <Text bold>{status.text}</Text>
      </Notification>
      <DimpleDivider />
    </>
  );
};

StatusBar.propTypes = {
  status: PropTypes.shape({
    isVisible: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  setStatus: PropTypes.func.isRequired
};

export default StatusBar;
